/* MK 01.10.2026 : textes traduits fournis par window.MK_I18N.c (layout/theme.liquid) ; anglais par défaut */
function mkT(k, d) { try { return (window.MK_I18N && window.MK_I18N.c && window.MK_I18N.c[k]) || d; } catch (e) { return d; } }
(function() {
  var STORAGE_KEY = 'mk_favorites';

  function getFavorites() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveFavorites(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }
  function isFavorited(handle) {
    return getFavorites().indexOf(handle) !== -1;
  }
  function toggleFavorite(handle) {
    var favs = getFavorites();
    var idx = favs.indexOf(handle);
    if (idx === -1) { favs.push(handle); } else { favs.splice(idx, 1); }
    saveFavorites(favs);
    return idx === -1;
  }
  function heartSVG(filled) {
   return '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M12 21s-7.6-4.6-10.1-9.4C.3 8.1 1.9 4.3 5.6 3.8c2-.3 3.9.7 6.4 3.4 2.5-2.7 4.4-3.7 6.4-3.4 3.7.5 5.3 4.3 3.7 7.8C19.6 16.4 12 21 12 21z" fill="' + (filled ? '#B22222' : 'none') + '" stroke="' + (filled ? '#B22222' : '#000') + '" stroke-width="1.4"/></svg>';
  }
  function makeButton(handle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mk-favorite-btn';
    btn.setAttribute('aria-label', mkT('s_cb10094b81de', "Add to favorites"));
    btn.setAttribute('data-handle', handle);
    var fav = isFavorited(handle);
    btn.innerHTML = heartSVG(fav);
    if (fav) btn.classList.add('is-favorited');
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var nowFav = toggleFavorite(handle);
      btn.innerHTML = heartSVG(nowFav);
      btn.classList.toggle('is-favorited', nowFav);
    });
    return btn;
  }
  function injectHearts() {
    document.querySelectorAll('.card-wrapper[data-product]').forEach(function(card) {
      var inner = card.querySelector('.card__inner');
      if (!inner || inner.querySelector('.mk-favorite-btn')) return;
      var handle = card.getAttribute('data-product');
      inner.appendChild(makeButton(handle));
    });
  }
   function injectPdpHeart() {
 var handle = window.mkPdpProductHandle;
 if (!handle) return;
 document.querySelectorAll('.product__title').forEach(function(title) {
 if (title.querySelector('.mk-favorite-btn')) return;
 var btn = makeButton(handle);
 btn.classList.add('mk-favorite-btn--pdp');
 title.appendChild(btn);
 });
 }
 function injectPdpWishlistLink() {
 var handle = window.mkPdpProductHandle;
 if (!handle) return;
 document.querySelectorAll('.product__buy_buttons').forEach(function(wrap) {
 if (wrap.querySelector('.mk-wishlist-btn--pdp')) return;
 var link = document.createElement('a');
 link.href = ((window.MK_I18N && window.MK_I18N.wishlist_url) || '/pages/wishlist');
 link.className = 'mk-wishlist-btn mk-wishlist-btn--pdp';
 link.innerHTML = '<span>' + mkT('s_252f36ac0e05', "My wishlist") + '</span>';
 wrap.appendChild(link);
 });
 }
  function cartSwatchColorValue(name) {
    var handle = name.toLowerCase().replace(/\s+/g, '');
    var overrides = { navyblue: 'navy', camel: '#c19a6b', champagne: '#f7e7ce' };
    if (overrides[handle]) return overrides[handle];
    if (handle === 'multicolor' || handle === 'striped') return null;
    return handle;
  }
  function fixCartSwatches() {
    var cartItemEls = document.querySelectorAll('.cart-item[data-variant-id]');
    if (!cartItemEls.length) return;
    fetch('/cart.js').then(function(res) { return res.json(); }).then(function(cart) {
      cartItemEls.forEach(function(el) {
        var variantId = el.getAttribute('data-variant-id');
        var item = cart.items.find(function(i) { return String(i.variant_id) === String(variantId); });
        if (!item || !item.options_with_values) return;
        var colorOpt = item.options_with_values.find(function(o) { return /color/i.test(o.name); });
        if (!colorOpt) return;
        var val = cartSwatchColorValue(colorOpt.value);
        if (!val) return;
        el.querySelectorAll('.product-option').forEach(function(g) {
          if (g.textContent.trim() === colorOpt.value) {
            g.style.setProperty('--swatch-color', val);
          }
        });
      });
    }).catch(function() {});
  }
  function injectWishlistTab() {
    var wrapper = document.querySelector('.facets__sort-wrapper');
    if (!wrapper || wrapper.querySelector('.mk-wishlist-tab')) return;
    var a = document.createElement('a');
    a.href = ((window.MK_I18N && window.MK_I18N.wishlist_url) || '/pages/wishlist');
    a.className = 'mk-wishlist-tab secondary_text';
    a.textContent = (window.MK_I18N && window.MK_I18N.my_wishlist) || 'My Wishlist';
    wrapper.appendChild(a);
  }
  function autoSelectSingleSize() {
    try {
      document.querySelectorAll('variant-radios fieldset').forEach(function (fieldset) {
        var inputs = fieldset.querySelectorAll('input[type="radio"]');
        if (inputs.length === 1 && !inputs[0].checked) {
          var label = fieldset.querySelector('label');
          if (label) label.click();
        }
      });
    } catch (e) {}
  }
  function injectAll() {
 injectHearts();
 injectPdpHeart();
 injectPdpWishlistLink();
    injectWishlistTab();
    fixCartSwatches();
    autoSelectSingleSize();
    observeProductGrid();
    observeCartDrawer();
  }
  // Le tri/filtre de la page collection (facets.js) remplace le HTML de
  // #ProductGridContainer par du contenu fraîchement fetché, sans jamais
  // redéclencher injectAll(). Résultat : les cœurs disparaissent après un
  // tri. On observe ce conteneur et on réinjecte les cœurs dès qu'il change.
  function observeProductGrid() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || container.getAttribute('data-mk-observed')) return;
    container.setAttribute('data-mk-observed', 'true');
    var observer = new MutationObserver(function() {
      injectHearts();
    });
    observer.observe(container, { childList: true, subtree: true });
  }
  // Même problème que ci-dessus, mais pour la popup "Produit ajouté au
  // panier" : elle est rendue en AJAX par cart-drawer.js sans déclencher
  // DOMContentLoaded / shopify:section:load / pageshow, donc les pastilles
  // de couleur n'étaient jamais recalculées pour cette popup précise
  // (seule la page /cart classique fonctionnait). On observe #CartDrawer
  // et on relance fixCartSwatches() dès que son contenu change.
  function observeCartDrawer() {
    var el = document.getElementById('CartDrawer');
    if (!el || el.getAttribute('data-mk-observed')) return;
    el.setAttribute('data-mk-observed', 'true');
    var observer = new MutationObserver(function() {
      fixCartSwatches();
    });
    observer.observe(el, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectAll);
  } else {
    injectAll();
  }
  document.addEventListener('shopify:section:load', injectAll);
  window.addEventListener('pageshow', injectAll);
})();